import { compareNatural } from './naturalOrder'
import { divisionAge, divisionGender } from './divisions'

/** One division order for every list and sort (owner, 2026-09-26): oldest age
 *  first, and within an age G before B. A name that does not parse as
 *  `<G|B><age>` (with or without the `U`) sorts after every one that does, in natural order. */
export function compareDivision(a: string, b: string): number {
  const ageA = divisionGender(a) ? divisionAge(a) : null
  const ageB = divisionGender(b) ? divisionAge(b) : null
  if (ageA !== null && ageB !== null) {
    if (ageA !== ageB) return ageB - ageA
    const g = (n: string) => (divisionGender(n) === 'G' ? 0 : 1)
    return g(a) - g(b)
  }
  if (ageA !== null) return -1
  if (ageB !== null) return 1
  return compareNatural(a, b)
}
